module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5n6v7"))).then(() => parcelRequire('2KbAe'));